var exports = {
  "_m": "popoverHeading__sxB6wW",
  "B5": "headingRow__Y-SFni",
  "G": "infoIcon__ePZDox",
  "jp": "popoverText__FoL-du",
  "PM": "popoverImage__k6PGW6",
  "YT": "actionsRow__ZQnG_R",
};

module.exports = exports;
